import $ from 'jquery';
import 'jquery-validation';

jQuery(function ($) {

  function initCommentForm() {
    var $form = $('.commentForm');
    $form.validate({
      rules: {
        comment: {
          required: true,
          minlength: 20
        }
      },
      messages: {
        comment: "Minimum length is 20 chars"
      },
      submitHandler: function (form) {
        $.ajax({
          data: $form.serialize(),
          success: function(response) {
            $.ajax({
              url: location.href,
              type: 'GET',
              success: function ( response ) {
                $('#comments').replaceWith( $(response).find('#comments') );
                initCommentForm();
                popupClose();
              }
            });
          },
        });
      }
    });
  }
  initCommentForm();


  function resetCommentForm( $commentForm ) {
    var $commentFormBlock = $commentForm.parents('.commentFormBlock');
    var $commentsSection = $commentFormBlock.parents('.commentsSection');
    var $title = $commentFormBlock.find('.commentFormBlock__title');
    $title.text( $title.data('title-default') );
    $commentFormBlock.find('input[name="comment_parent"]').val( 0 );
    $commentFormBlock.appendTo( $commentsSection );
    $commentForm.validate().resetForm();
  }


  //comment reply link handler
  $(document).on('click', '.actionCommentReply', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $comment = $this.parents('li');
    var commentID = $comment.data('comment-id');
    var replyTo = $this.data('replyto');
    var $commentsSection = $this.parents('.commentsSection');
    var $commentFormBlock = $commentsSection.find('.commentFormBlock');
    var $commentForm = $commentFormBlock.find('.commentForm');
    $commentFormBlock.find('.commentFormBlock__title').text( replyTo );
    $commentFormBlock.find('input[name="comment_parent"]').val( commentID );
    $commentFormBlock.appendTo('#comment-' + commentID + ' > .comment__inner');
    $commentForm.trigger('reset');
  });


  //cancel comment reply handler
  $(document).on('click', '.commentForm__buttonCancel', function () {
    var $this = $(this);
    var $commentForm = $this.parents('.commentForm');
    resetCommentForm( $commentForm );
  });
});